<template>
    <div class="">
        <!-- <h1>{{ title }}</h1> -->

        <Atom1Loader v-if="loading" />

        <form class="row g-3" v-else>

            <div class="col-md-12">
                <div class="form-floating">
                    <input v-model="email" class="form-control" placeholder="Email">
                    <label>Email</label>
                    <div v-if="v$.email.$error" class="invalid-feedback animated fadeInDown" style="display: block;">
                        {{ validationMessage(v$.email) }}
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-floating mt-2">
                            <input v-model="firstName" class="form-control" placeholder="Nombres..."
                                :class="{ 'is-invalid': v$.firstName.$error }">
                            <label>Nombres</label>
                            <div v-if="v$.firstName.$error" class="invalid-feedback animated fadeInDown"
                                style="display: block;">
                                {{ validationMessage(v$.firstName) }}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-floating mt-2">
                            <input v-model="lastName" class="form-control" placeholder="Apellidos...">
                            <label>Apellidos</label>
                            <div v-if="v$.lastName.$error" class="invalid-feedback animated fadeInDown"
                                style="display: block;">
                                {{ validationMessage(v$.lastName) }}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-floating mt-2">
                            <input v-model="phone" class="form-control" placeholder="Teléfono..." type="number">
                            <label>Teléfono</label>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-floating mt-2">
                            <input v-model="document" class="form-control" placeholder="Documento...">
                            <label>Documento</label>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <!-- Roles -->
                        <div class="form-floating mt-2">
                            <Multiselect v-model="role" 
                                         select-label="" 
                                         :loading="rolesLoading"
                                         :options="roles" 
                                         track-by="id" 
                                         label="name" 
                                         @open="getRoles" 
                                         placeholder="Seleccione un rol...">

                            </Multiselect>
                            <div v-if="v$.role.$error" class="invalid-feedback animated fadeInDown"
                                style="display: block;">
                                {{ validationMessage(v$.role) }}
                            </div>


                        </div>
                    </div>
                </div>

            </div>

            <div class="text-center">
                <button v-if="type == 'C'" class="btn btn-primary" @click.prevent="createUser">Guardar</button>
                <button v-else class="btn btn-primary" @click.prevent="updateUser">Actualizar</button>
            </div>
        </form>
    </div>
</template>

<script>

import useValidate from '@vuelidate/core';
import { required, minLength } from '@vuelidate/validators';

import toastMixin from '@/mixins/toastMixin';
import validatorMixin from '@/mixins/validatorMixin';
import accountMixin from '@/mixins/accountMixin';

import axios from "axios";

import { checkCatch } from "@/utils";

import Atom1Loader from '@/components/Utils/Loaders/Atom1Loader.vue';

import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.css';

export default {

    name: 'UserManagerComponent',

    mixins: [validatorMixin, toastMixin, accountMixin],

    components: { Atom1Loader, Multiselect },

    props: {

        type: { type: String, required: true }
    },

    data() {

        return {

            v$: useValidate({ $stopPropagation: true }),

            loading: false,
            rolesLoading: false,

            title: this.type == 'E' ? 'Editar usuario' : 'Crear Usuario',

            id: 0,
            firstName: '',
            lastName: '',
            email: '',
            phone: 0,
            document: '',
            role: null,

            roles: [],
        };
    },

    validations() {

        return {

            firstName: { required, minLength: minLength(3) },
            lastName: { required, minLength: minLength(3) },
            email: { required },
            phone: { required },
            document: { required },
            role: { required, minLength: minLength(1) },
        };
    },

    methods: {

        async createUser() {

            this.v$.$validate();

            if (this.v$.$error) {

                this.showNotification({
                    title: 'Debe ajustar los errores de validación',
                    description: '',
                    type: 'danger',
                    timeout: 4,
                });
                return;
            }

            this.loading = true;

            const data = {

                username: this.email,
                email: this.email,
                password: this.document,
                first_name: this.firstName,
                last_name: this.lastName,
                role_id: this.role.id,
                extra_data: {
                    phone: this.phone,
                    document: this.document
                }
            };

            const headers = {

                'Authorization': `Bearer ${this.accountUser.token}`
            };

            await axios.post(`${this.$env.API_BASE_URL}users/create/`, data, { headers })
                .then(() => {

                    this.$emit('userCreated');
                    this.loading = false;

                    this.showNotification({
                        title: 'Éxito',
                        description: 'Usuario creado con éxito',
                        timeout: 4,
                    });

                }).catch((error) => {

                    checkCatch(error);
                });
        },

        async getRoles() {

            this.rolesLoading = true;

            const headers = {

                'Authorization': `Bearer ${this.accountUser.token}`
            };
            await axios.get(`${this.$env.API_BASE_URL}users/get_roles/`, { headers }).then((response) => {

                const { data } = response;

                this.roles = data.map(item => {

                    const role = {
                        id: item.id,
                        name: item.name
                    };

                    return role;
                });
                this.rolesLoading = false;

            }).catch((error) => {

                checkCatch(error);
            });
        },

        async updateUser() {

            this.v$.$validate();

            if (this.v$.$error) {

                this.showNotification({
                    title: 'Debe ajustar los errores de validación',
                    description: '',
                    type: 'danger',
                    timeout: 4,
                });
                return;
            }

            this.loading = true;

            const data = {

                id: this.id,
                username: this.email,
                email: this.email,
                password: this.document,
                first_name: this.firstName,
                last_name: this.lastName,
                role_id: this.role.id,
                extra_data: {
                    phone: this.phone,
                    document: this.document
                }
            };

            const headers = {

                'Authorization': `Bearer ${this.accountUser.token}`
            };

            await axios.put(`${this.$env.API_BASE_URL}users/update/${this.id}/`, data, { headers })
                .then(() => {

                    this.$emit('userUpdated');
                    this.loading = false;

                    this.showNotification({
                        title: 'Éxito',
                        description: 'Usuario actualizado con éxito',
                        timeout: 4,
                    });

                }).catch((error) => {

                    checkCatch(error);
                });
        },

        setUser(user){

            this.id = user.id;
            this.firstName = user.first_name;
            this.lastName = user.last_name;
            this.email = user.email;
            this.phone = user.phone
            this.document = user.document;
            this.role = user.role;
        },
    },
}
</script>